import React, { useState } from "react";
import { Form, Input, Button, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import "./LoginPageStyle.scss"; // Reuse login styles
import logo from "../assets/logo.png";
import { NetworkInfo } from "../constants/network.ts";
import { apiCall } from "../api/apiRoutes.ts";
import showMessageQueue from '../utils/messageUtils.js';

const { Title, Text } = Typography;

const SignUp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [messages, contextHolder] = message.useMessage();
  const navigate=useNavigate();
  const handleSignUp = async (values) => {
    const { first_name,last_name, email, password, confirmPassword } = values;
    if(!first_name || !last_name || !email){
        showMessageQueue(messages,"error","First name, Last name and Email is required!")
        return
    }
    if (!password || !confirmPassword) {
        showMessageQueue(messages,"error","Password and confirm password is required!")
        return;
    }

    if (password !== confirmPassword) {
      showMessageQueue(messages,"error","Password and Confirm Password must match!")
      // messages.error("Password and Confirm Password must match!");
      return;
    }

    const payload={
        email:email,
        first_name:first_name,
        last_name:last_name,
        password:password
    }

    try {
      setIsLoading(true);
      const response=await apiCall(payload,`${NetworkInfo.endpoints.auth}${NetworkInfo.endpoints.create}`,"post",false,false,false);
      if (response?.success || response?.data?.success) {
        showMessageQueue(messages,"success","User registered successfully")
        setTimeout(()=>{
            navigate("/login");
        },3000)    
        }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "User already exists!";
      showMessageQueue(messages,"error",errorMessage)
    }finally {
      setIsLoading(false);
    }
  };


  return (  
    <>
        <div className="login-container">
             {contextHolder}
             <div className="login-card">
                 <img src={logo} alt="Logo" className="login-logo" />
                    <>
                    <Title level={4} className="login-title mt-2">Create your Usmon Insights Account</Title>
                    <Form form={form} layout="vertical" onFinish={handleSignUp}   className="left-align-form" requiredMark={false}>
                        <Form.Item
                            label={
                            <>
                                First Name
                                <span style={{ color: "red" }}> *</span>
                            </>
                            }
                            name="first_name"
                            rules={[
                                    { required: true, whitespace: true, message: "Please enter your first name!" },
                                    { max: 50, message: "First name must be 50 characters or fewer!" }
                                ]}
                            >
                            <Input placeholder="Enter your first name" />
                        </Form.Item>

                        <Form.Item
                            label={
                            <>
                                Last Name
                                <span style={{ color: "red" }}> *</span>
                            </>
                            }
                            name="last_name"
                            rules={[
                                    { required: true, whitespace: true, message: "Please enter your last name!" },
                                    { max: 50, message: "Last name must be 50 characters or fewer!" }
                                ]}                            >
                            <Input placeholder="Enter your last name" />
                        </Form.Item>

                        <Form.Item
                            label={
                            <>
                                Email
                                <span style={{ color: "red" }}> *</span>
                            </>
                            }
                            name="email"
                            rules={[
                                { required: true, message: "Please enter your email!" },
                                { type: "email", message: "Please enter a valid email!" },
                                { 
                                    validator: (_, value) => { 
                                        if (value && value.toLowerCase().endsWith("@usmon.com")) { 
                                            return Promise.reject(new Error("You cannot sign up with an @usmon.com email address. Please use a different email.")); 
                                        } 
                                        return Promise.resolve(); 
                                    } 
                                } 
                            ]}
                        >
                            <Input placeholder="Enter your email" />
                        </Form.Item>

                        <Form.Item
                            label={
                            <>
                                Password
                                <span style={{ color: "red" }}> *</span>
                            </>
                            }
                            name="password"
                            rules={[
                                { required: true,whitespace:true, message: "Please enter your password!" },
                                { min: 8, message: "Password must be at least 8 characters long!" },
                            ]}
                        >
                            <Input.Password placeholder="Enter your password" />
                        </Form.Item>

                        <Form.Item
                            label={
                            <>
                                Confirm Password
                                <span style={{ color: "red" }}> *</span>
                            </>
                            }
                            name="confirmPassword"
                            dependencies={['password']}
                            rules={[
                                { required: true,whitespace:true, message: "Please confirm your password!" },
                            ]}
                        >
                            <Input.Password placeholder="Re-enter your password" />
                        </Form.Item>
                    
                        <Form.Item>
                            <Button 
                                type="primary" 
                                htmlType="submit" 
                                loading={isLoading} 
                                block
                                disabled={isLoading}
                                className="login-button"
                            >
                                {isLoading ? "Signing Up..." : "Sign Up"}
                            </Button>
                        </Form.Item>
                    </Form>

                      <Text className="login-note">
                            Already have an account?{' '}
                            <span
                                style={{ color: '#1890ff', cursor: 'pointer' }}
                                onClick={() => navigate('/')}
                            >
                                Log In
                            </span>
                      </Text>
                    </>
             </div>
        </div>
    </>
  );
};

export default SignUp;
